// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2wfVM","subheader":"ReorderModal_subheader__2oBXi","listWrap":"ReorderModal_listWrap__OxfDd"};